import React from 'react';
import { Svg } from '@/shared/ui/Svg';
import ChevronDownIcon from '@/shared/assets/icons/chevron-down.svg';
import styles from './IntakeActions.module.scss';

interface IntakeActionsProps {
  onToggle?: () => void;
  isExpanded?: boolean;
  hasGroups?: boolean;
}

export const IntakeActions: React.FC<IntakeActionsProps> = ({
  onToggle,
  isExpanded = false,
  hasGroups = false,
}) => {
  const handleToggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    onToggle?.();
  };

  return (
    <div className={styles.actions}>
      {hasGroups && (
        <button type="button" onClick={handleToggle} className={styles.actionButton}>
          <Svg
            Icon={ChevronDownIcon}
            width={20}
            height={20}
            className={isExpanded ? styles.chevronUp : ''}
          />
        </button>
      )}
    </div>
  );
};
